export const RedX = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.7914 6L18 7.20857L13.2086 12L18 16.7914L16.7914 18L12 13.2086L7.20857 18L6 16.7914L10.7914 12L6 7.20857L7.20857 6L12 10.7914L16.7914 6Z"
      fill="#E23232"
    />
  </svg>
);
